import { render, staticRenderFns } from "./LinhaDeItem.vue?vue&type=template&id=2d80d373&scoped=true"
import script from "./LinhaDeItem.vue?vue&type=script&setup=true&lang=js"
export * from "./LinhaDeItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LinhaDeItem.vue?vue&type=style&index=0&id=2d80d373&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d80d373",
  null
  
)

export default component.exports